import { BaseDO } from "../base.model";
import { ProposalClientDO } from "./proposalClientDO";
import { ProposalCoverageDO } from "./proposalCoverageDO";
import { ProposalAgentDO } from "./proposalAgentDO";
import { ProposalPaymentDO } from "./proposalPaymentDO";
import { ProposalAdditionalFieldDO } from "./proposalAdditionalFieldDO";
import { ProposalBeneficiaryDO } from "./proposalBeneficiaryDO";
import { OtherProposalDO } from "./otherProposalDO";
import { ProposalPremiumBreakupDO } from "./proposalPremiumBreakupDO";
import { ProposalReceiptDO } from "./proposalReceiptDO";

export class ProposalDO extends BaseDO {

    public id: null;
    public getid(): null {
        return this.id;
    }
    public setid(value: null) {
        this.id = value;
    }

    public leadRefNum: null;
    public getleadRefNum(): null {
        return this.leadRefNum;
    }
    public setleadRefNum(value: null) {
        this.leadRefNum = value;
    }

    public quotationRefNum: null;
    public getquotationRefNum(): null {
        return this.quotationRefNum;
    }
    public setquotationRefNum(value: null) {
        this.quotationRefNum = value;
    }

    public proposalRefNum: null;
    public getproposalRefNum(): null {
        return this.proposalRefNum;
    }
    public setproposalRefNum(value: null) {
        this.proposalRefNum = value;
    }

    public proposalNum: null;
    public getproposalNum(): null {
        return this.proposalNum;
    }
    public setproposalNum(value: null) {
        this.proposalNum = value;
    }

    public proposalEntryDt: Date = null;
    public getproposalEntryDt(): Date {
        return this.proposalEntryDt;
    }
    public setproposalEntryDt(value: Date) {
        this.proposalEntryDt = value;
    }

    public proposalReceivedDt: Date = null;
    public getproposalReceivedDt(): Date {
        return this.proposalReceivedDt;
    }
    public setproposalReceivedDt(value: Date) {
        this.proposalReceivedDt = value;
    }

    public proposalSignedDt: Date = null;
    public getproposalSignedDt(): Date {
        return this.proposalSignedDt;
    }
    public setproposalSignedDt(value: Date) {
        this.proposalSignedDt = value;
    }

    public policyCommencementDt: Date = null;
    public getpolicyCommencementDt(): Date {
        return this.policyCommencementDt;
    }
    public setpolicyCommencementDt(value: Date) {
        this.policyCommencementDt = value;
    }

    public policyExpiryDt: Date = null;
    public getpolicyExpiryDt(): Date {
        return this.policyExpiryDt;
    }
    public setpolicyExpiryDt(value: Date) {
        this.policyExpiryDt = value;
    }

    public policyIssueDt: null;
    public getpolicyIssueDt(): null {
        return this.policyIssueDt;
    }
    public setpolicyIssueDt(value: null) {
        this.policyIssueDt = value;
    }

    public purposeOfInsuranceCd: String = null;
    public getpurposeOfInsuranceCd(): String {
        return this.purposeOfInsuranceCd;
    }
    public setpurposeOfInsuranceCd(value: String) {
        this.purposeOfInsuranceCd = value;
    }

    public submissionModeCd: String = null;
    public getsubmissionModeCd(): String {
        return this.submissionModeCd;
    }
    public setsubmissionModeCd(value: String) {
        this.submissionModeCd = value;
    }

    public proposalTypeCd: String = null;
    public getproposalTypeCd(): String {
        return this.proposalTypeCd;
    }
    public setproposalTypeCd(value: String) {
        this.proposalTypeCd = value;
    }

    public baseProductFamilyCd: String = null;
    public getbaseProductFamilyCd(): String {
        return this.baseProductFamilyCd;
    }
    public setbaseProductFamilyCd(value: String) {
        this.baseProductFamilyCd = value;
    }

    public baseProductCd: String = null;
    public getbaseProductCd(): String {
        return this.baseProductCd;
    }
    public setbaseProductCd(value: String) {
        this.baseProductCd = value;
    }

    public baseProductTypeCd: String = null;
    public getbaseProductTypeCd(): String {
        return this.baseProductTypeCd;
    }
    public setbaseProductTypeCd(value: String) {
        this.baseProductTypeCd = value;
    }

    public productPlanOptionCd: String = null;
    public getproductPlanOptionCd(): String {
        return this.productPlanOptionCd;
    }
    public setproductPlanOptionCd(value: String) {
        this.productPlanOptionCd = value;
    }

    public baseProductVersion: String = null;
    public getbaseProductVersion(): String {
        return this.baseProductVersion;
    }
    public setbaseProductVersion(value: String) {
        this.baseProductVersion = value;
    }

    public baseAgentId: String = null;
    public getbaseAgentId(): String {
        return this.baseAgentId;
    }
    public setbaseAgentId(value: String) {
        this.baseAgentId = value;
    }

    public statusCd: String = null;
    public getstatusCd(): String {
        return this.statusCd;
    }
    public setstatusCd(value: String) {
        this.statusCd = value;
    }

    public processStatusCd: String = null;
    public getprocessStatusCd(): String {
        return this.processStatusCd;
    }
    public setprocessStatusCd(value: String) {
        this.processStatusCd = value;
    }

    public stageCd: String = null;
    public getstageCd(): String {
        return this.stageCd;
    }
    public setstageCd(value: String) {
        this.stageCd = value;
    }

    public validationStatusCd: String = null;
    public getvalidationStatusCd(): String {
        return this.validationStatusCd;
    }
    public setvalidationStatusCd(value: String) {
        this.validationStatusCd = value;
    }

    public uwDecisionCd: String = null;
    public getuwDecisionCd(): String {
        return this.uwDecisionCd;
    }
    public setuwDecisionCd(value: String) {
        this.uwDecisionCd = value;
    }

    public uwDecisionValue: String = null;
    public getuwDecisionValue(): String {
        return this.uwDecisionValue;
    }
    public setuwDecisionValue(value: String) {
        this.uwDecisionValue = value;
    }

    public uwDecisionDt: Date = null;
    public getuwDecisionDt(): Date {
        return this.uwDecisionDt;
    }
    public setuwDecisionDt(value: Date) {
        this.uwDecisionDt = value;
    }

    public workFlowDecisionCd: String = null;
    public getworkFlowDecisionCd(): String {
        return this.workFlowDecisionCd;
    }
    public setworkFlowDecisionCd(value: String) {
        this.workFlowDecisionCd = value;
    }

    public finalSumInsured: Number = null;
    public getfinalSumInsured(): Number {
        return this.finalSumInsured;
    }
    public setfinalSumInsured(value: Number) {
        this.finalSumInsured = value;
    }

    public finalPremiumAmt: Number = null;
    public getfinalPremium(): Number {
        return this.finalPremiumAmt;
    }
    public setfinalPremium(value: Number) {
        this.finalPremiumAmt = value;
    }

    public premiumStatusCd: String = null;
    public getpremiumStatusCd(): String {
        return this.premiumStatusCd;
    }
    public setpremiumStatusCd(value: String) {
        this.premiumStatusCd = value;
    }

    public policyTerm: Number = null;
    public getproposalterm(): Number {
        return this.policyTerm;
    }
    public setproposalterm(value: Number) {
        this.policyTerm = value;
    }

    public ruleEffectiveDate: Date = null;
    public getruleEffectiveDate(): Date {
        return this.ruleEffectiveDate;
    }
    public setruleEffectiveDate(value: Date) {
        this.ruleEffectiveDate = value;
    }

    public underwitingTypeCd: String = null;
    public getunderwitingTypeCd(): String {
        return this.underwitingTypeCd;
    }
    public setunderwitingTypeCd(value: String) {
        this.underwitingTypeCd = value;
    }

    public ratingTypeCd: String = null;
    public getratingTypeCd(): String {
        return this.ratingTypeCd;
    }
    public setratingTypeCd(value: String) {
        this.ratingTypeCd = value;
    }

    public coResponseCd: String = null;
    public getCoResponseCd(): String {
        return this.coResponseCd;
    }
    public setcoResponseCd(value: String) {
        this.coResponseCd = value;
    }

    public primaryInsuredValue: Number = null;
    public getprimaryInsuredValue(): Number {
        return this.primaryInsuredValue;
    }
    public setprimaryInsuredValue(value: Number) {
        this.primaryInsuredValue = value;
    }

    public estimatedPrimaryInsuredValue: Number = null;
    public getestimatedPrimaryInsuredValue(): Number {
        return this.estimatedPrimaryInsuredValue;
    }
    public setestimatedPrimaryInsuredValue(value: Number) {
        this.estimatedPrimaryInsuredValue = value;
    }

    public totOtherInsurableValue: Number = null;
    public gettotOtherInsurableValue(): Number {
        return this.totOtherInsurableValue;
    }
    public settotOtherInsurableValue(value: Number) {
        this.totOtherInsurableValue = value;
    }

    public sumInsuredAmt: Number = null;
    public getsumInsuredAmt(): Number {
        return this.sumInsuredAmt;
    }
    public setsumInsuredAmt(value: Number) {
        this.sumInsuredAmt = value;
    }

    public riskCategoryCd: String = null;
    public getriskCategoryCd(): String {
        return this.riskCategoryCd;
    }
    public setriskCategoryCd(value: String) {
        this.riskCategoryCd = value;
    }

    public currencyCd: String = null;
    public getcurrencyCd(): String {
        return this.currencyCd;
    }
    public setcurrencyCd(value: String) {
        this.currencyCd = value;
    }

    public promoCd: String = null;
    public getpromoCode(): String {
        return this.promoCd;
    }
    public setpromoCode(value: String) {
        this.promoCd = value;
    }

    public proposalCoverages: ProposalCoverageDO[] = [];
    public getproposalCoverages(): ProposalCoverageDO[] {
        return this.proposalCoverages;
    }
    public setproposalCoverages(value: ProposalCoverageDO[]) {
        this.proposalCoverages = value;
    }

    public proposalAgents: ProposalAgentDO[] = [];
    public getproposalAgents(): ProposalAgentDO[] {
        return this.proposalAgents;
    }
    public setproposalAgents(value: ProposalAgentDO[]) {
        this.proposalAgents = value;
    }

    public proposalClients: ProposalClientDO[] = [];
    public getproposalClients(): ProposalClientDO[] {
        return this.proposalClients;
    }
    public setproposalClients(value: ProposalClientDO[]) {
        this.proposalClients = value;
    }

    public proposalPayments: ProposalPaymentDO[] = [];
    public getproposalPayments(): ProposalPaymentDO[] {
        return this.proposalPayments;
    }
    public setproposalPayments(value: ProposalPaymentDO[]) {
        this.proposalPayments = value;
    }

    public proposalAdditionalFields: ProposalAdditionalFieldDO[] = [];
    public getproposalAdditionalFields(): ProposalAdditionalFieldDO[] {
        return this.proposalAdditionalFields;
    }
    public setproposalAdditionalFields(value: ProposalAdditionalFieldDO[]) {
        this.proposalAdditionalFields = value;
    }

    public proposalTripDO: null;
    public getproposalTripDO(): null {
        return this.proposalTripDO;
    }
    public setproposalTripDO(value: null) {
        this.proposalTripDO = value;
    }

    public proposalBeneficiaries: ProposalBeneficiaryDO[] = [];
    public getproposalBeneficiaries(): ProposalBeneficiaryDO[] {
        return this.proposalBeneficiaries;
    }
    public setproposalBeneficiaries(value: ProposalBeneficiaryDO[]) {
        this.proposalBeneficiaries = value;
    }

    public otherProposals: OtherProposalDO[] = [];
    public getotherproposals(): OtherProposalDO[] {
        return this.otherProposals;
    }
    public setotherproposals(value: OtherProposalDO[]) {
        this.otherProposals = value;
    }

    public proposalPremiumBreakups: ProposalPremiumBreakupDO[] = [];
    public getproposalPremiumBreakups(): ProposalPremiumBreakupDO[] {
        return this.proposalPremiumBreakups;
    }
    public setproposalPremiumBreakups(value: ProposalPremiumBreakupDO[]) {
        this.proposalPremiumBreakups = value;
    }

    public dueDt: Date = null;
    public getdueDt(): Date {
        return this.dueDt;
    }
    public setdueDt(value: Date) {
        this.dueDt = value;
    }

    public pdfTemplateCd: String = null;
    public getpdfTemplateCd(): String {
        return this.pdfTemplateCd;
    }
    public setpdfTemplateCd(value: String) {
        this.pdfTemplateCd = value;
    }

    public errorFl: Boolean = null;
    public geterrorFl(): Boolean {
        return this.errorFl;
    }
    public seterrorFl(value: Boolean) {
        this.errorFl = value;
    }

    public baseAnnualPremium: Number = null;
    public getbaseAnnualPremium(): Number {
        return this.baseAnnualPremium;
    }
    public setbaseAnnualPremium(value: Number) {
        this.baseAnnualPremium = value;
    }

    public paymentFrequencyCd: String = null;
    public getpaymentFrequencyCd(): String {
        return this.paymentFrequencyCd;
    }
    public setpaymentFrequencyCd(value: String) {
        this.paymentFrequencyCd = value;
    }

    public proposalReceipts: ProposalReceiptDO[] = [];
    public getproposalReceipts(): ProposalReceiptDO[] {
        return this.proposalReceipts;
    }
    public setproposalReceipts(value: ProposalReceiptDO[]) {
        this.proposalReceipts = value;
    }

    public proposalSourceCd: null;
    public getproposalSourceCd(): null {
        return this.proposalSourceCd;
    }
    public setproposalSourceCd(value: null) {
        this.proposalSourceCd = value;
    }
}